import React from "react";

var Footer = () => {
  return (
    <footer>
      <p>(C) NoteKeeper 2022</p>
    </footer>
  );
}

export default Footer;
